import { render, staticRenderFns } from "./FloatingChat.vue?vue&type=template&id=355ca26c&scoped=true&"
import script from "./FloatingChat.vue?vue&type=script&lang=js&"
export * from "./FloatingChat.vue?vue&type=script&lang=js&"
import style0 from "./FloatingChat.vue?vue&type=style&index=0&id=355ca26c&prod&scoped=true&lang=css&"
import style1 from "./FloatingChat.vue?vue&type=style&index=1&id=355ca26c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355ca26c",
  null
  
)

export default component.exports